import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import './App.css';
import './shared/css/shared.css'
import './shared/css/pageList.css'
import './shared/css/filterModal.css'
import './shared/components/form/inputDefault.css'

//components
import Navbar from "./shared/navbar/navbar";
import Message from "./shared/components/FlashMessage/Message"
import Container from "./shared/container/container"
import Footer from "./shared/footer/footer"
import Breadcrumb from "./shared/components/Breadcrumb/Breadcrumb"
import BackupOverdueModal from "./shared/components/BackupOverdueModal/BackupOverdueModal"


/* private pages */
import PrivateRoute from './shared/privateRoute/PrivateRoute';


//pages
import Login from "./pages/auth/pages/Login"
import Register from "./pages/auth/pages/Register"
import Home from './pages/home/Home'

//client
import Client from "./pages/Client/Client"
import MyClient from "./pages/Client/MyClient"


//system user
import ListSystemUser from './pages/system_user/ListSystemUser';
import ListHistoric from './pages/Historic/ListHistoric';
import Backup from './pages/Backup/Backup';

//region
import ListRegion from './pages/region/ListRegion';


//Horimetro
import ListHorimetro from './pages/Horimetro/ListHorimetro'
import EditHorimetro from './pages/Horimetro/EditHorimetro'

import Generator from './pages/Generator/Generator';

import ServiceOrder from './pages/ServiceOrder/ServiceOrder/ServiceOrder';
import ServiceOrderOpen from './pages/ServiceOrder/ServiceOrderOpen/ServiceOrderOpen';
import ServiceOrderReview from './pages/ServiceOrder/ServiceOrderReview/ServiceOrderReview';
import ServiceOrderConcluded from './pages/ServiceOrder/ServiceOrderConcluded/ServiceOrderConcluded';
import ServiceOrderPDFPreview from './pages/ServiceOrder/ServiceOrderConcluded/ServiceOrderPDFPreview';
import MaintenanceSchedule from './pages/MaintenanceSchedule/MaintenanceSchedule';

import ChecklistGroup from './pages/ChecklistGroup/ChecklistGroup';
import ChecklistItem from './pages/ChecklistItem/ChecklistItem';
import Procedure from './pages/Procedure/Procedure';

/* context */
import { UserProvider } from './context/UserContext';

const AUTH_PAGES = ['/login', '/register']
const BARE_PAGE_PREFIXES = ['/serviceOrder/pdf-preview']

function AppLayout() {
  const location = useLocation()
  const isAuthPage = AUTH_PAGES.includes(location.pathname)
  const isBarePage = isAuthPage || BARE_PAGE_PREFIXES.some(p => location.pathname.startsWith(p))

  return (
    <>
      {!isBarePage && <Navbar />}
      {!isBarePage && <BackupOverdueModal />}
      <div className={isBarePage ? 'page-layout page-layout-full' : 'page-layout'}>
        {!isBarePage && <Breadcrumb />}
        <Message />
        <Container>
          <Routes>
            <Route path="/login" exact element={<Login />} />
            <Route path="/register" exact element={<Register />} />

            <Route element={<PrivateRoute />}>
              <Route path='/' exact element={<Home />} />
              <Route path='/client' exact element={<Client />} />
              <Route path='/myclient' exact element={<MyClient />} />
              <Route path='/generator' exact element={<Generator />} />

              <Route path='/region/list' exact element={<ListRegion />} />

              <Route path='/horimetro/list' exact element={<ListHorimetro />} />
              <Route path='/horimetro/list/:notificationFilter' exact element={<ListHorimetro />} />
              <Route path='/horimetro/edit/:id' exact element={<EditHorimetro />} />

              <Route path='/serviceOrder' exact element={<ServiceOrder />} />
              <Route path='/serviceOrderOpen' exact element={<ServiceOrderOpen />} />
              <Route path='/serviceOrderReview' exact element={<ServiceOrderReview />} />
              <Route path='/serviceOrderConcluded' exact element={<ServiceOrderConcluded />} />
              <Route path='/serviceOrder/pdf-preview/:id' exact element={<ServiceOrderPDFPreview />} />
              <Route path='/maintenanceSchedule' exact element={<MaintenanceSchedule />} />
              <Route path='/checklistGroup' exact element={<ChecklistGroup />} />
              <Route path='/checklistItem' exact element={<ChecklistItem />} />
              <Route path='/procedure' exact element={<Procedure />} />

              <Route path='/system-user/list' exact element={<ListSystemUser />} />
              <Route path='/historic/list' exact element={<ListHistoric />} />
              <Route path='/backup' exact element={<Backup />} />
            </Route>
          </Routes>
        </Container>
      </div>
      {!isBarePage && <Footer />}
    </>
  )
}

function App() {
  return (
    <Router>
      <UserProvider>
        <AppLayout />
      </UserProvider>
    </Router>
  );
}

export default App;
